var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconContent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.3562 53.2125C42.9794 53.2125 53.2125 42.9794 53.2125 30.3562C53.2125 17.7331 42.9794 7.5 30.3562 7.5C17.7331 7.5 7.5 17.7331 7.5 30.3562C7.5 42.9794 17.7331 53.2125 30.3562 53.2125Z",
    fill: "url(#paint0_radial_4760_27374)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.3562 53.2125C42.9794 53.2125 53.2125 42.9794 53.2125 30.3562C53.2125 17.7331 42.9794 7.5 30.3562 7.5C17.7331 7.5 7.5 17.7331 7.5 30.3562C7.5 42.9794 17.7331 53.2125 30.3562 53.2125Z",
    fill: "url(#paint1_radial_4760_27374)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M30.3562 53.2125C42.9794 53.2125 53.2125 42.9794 53.2125 30.3562C53.2125 17.7331 42.9794 7.5 30.3562 7.5C17.7331 7.5 7.5 17.7331 7.5 30.3562C7.5 42.9794 17.7331 53.2125 30.3562 53.2125Z",
    fill: "url(#paint2_radial_4760_27374)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M30.3562 53.2125C42.9794 53.2125 53.2125 42.9794 53.2125 30.3562C53.2125 17.7331 42.9794 7.5 30.3562 7.5C17.7331 7.5 7.5 17.7331 7.5 30.3562C7.5 42.9794 17.7331 53.2125 30.3562 53.2125Z",
    fill: "url(#paint3_radial_4760_27374)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2778 30.165C21.2778 30.165 17.6634 30.165 16.3983 27.5604C16.3239 27.401 16.2708 27.2202 16.2495 27.0396C16.2176 26.6781 16.5046 26.2635 17.185 26.5506C21.331 28.3152 23.4891 27.0714 25.1049 26.1997C25.7322 25.8595 26.3807 26.4655 26.2424 27.0714C26.1999 27.2522 26.1786 27.4329 26.1042 27.5924C24.8923 30.1863 21.2778 30.165 21.2778 30.165Z",
    fill: "url(#paint4_radial_4760_27374)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2542 19.5549C24.2329 18.6407 23.2229 18.0985 21.522 18.141C20.0762 18.1835 16.9189 19.0659 14.814 21.9468C14.4206 22.4784 15.0585 22.7441 15.4412 22.3934C16.7488 21.2133 20.3101 19.64 23.1273 19.8738C24.2648 19.9589 24.2542 19.5549 24.2542 19.5549Z",
    fill: "url(#paint5_linear_4760_27374)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4558 37.0431C40.2644 37.0113 40.0731 37.0644 39.9349 37.2026C37.4792 39.5095 33.6946 40.7427 30.8456 40.7427H30.3565H29.8675C27.0185 40.7427 23.2232 39.5095 20.7782 37.2026C20.6399 37.075 20.4486 37.0113 20.2572 37.0431C20.0659 37.075 19.9596 37.2983 20.0552 37.479C22.1495 41.1041 26.0297 43.3578 30.2396 43.3578H30.3671H30.4947C34.7045 43.3578 38.5847 41.1147 40.679 37.479C40.7641 37.2983 40.6578 37.0857 40.4558 37.0431Z",
    fill: "#643800"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4558 37.0431C40.2644 37.0113 40.0731 37.0644 39.9349 37.2026C37.4792 39.5095 33.6946 40.7427 30.8456 40.7427H30.3565H29.8675C27.0185 40.7427 23.2232 39.5095 20.7782 37.2026C20.6399 37.075 20.4486 37.0113 20.2572 37.0431C20.0659 37.075 19.9596 37.2983 20.0552 37.479C20.0765 37.5109 20.0978 37.5534 20.1191 37.5853C20.321 37.4684 20.523 37.362 20.7463 37.6066C23.0744 40.2218 26.5294 41.7845 30.2289 41.7845H30.3565H30.4841C34.2049 41.7845 37.6811 40.2005 40.0093 37.5534C40.2219 37.3089 40.4239 37.4259 40.6153 37.5534C40.6259 37.5321 40.6472 37.5003 40.6578 37.479C40.7641 37.2983 40.6578 37.0857 40.4558 37.0431Z",
    fill: "url(#paint6_linear_4760_27374)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1155 26.1997C23.4995 27.0821 21.3415 28.3259 17.1955 26.5506C16.6321 26.3061 16.3451 26.5612 16.2812 26.8588C16.8447 26.4974 17.7377 28.2834 21.2139 28.2834C25.2324 28.2834 25.8384 26.0722 26.2743 26.8695C26.2423 26.338 25.6682 25.8914 25.1155 26.1997Z",
    fill: "url(#paint7_linear_4760_27374)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4346 30.165C39.4346 30.165 43.0491 30.165 44.3141 27.5604C44.3885 27.401 44.4417 27.2202 44.463 27.0396C44.4948 26.6781 44.2078 26.2635 43.5274 26.5506C39.3814 28.3152 37.2234 27.0714 35.6075 26.1997C34.9803 25.8595 34.3317 26.4655 34.47 27.0714C34.5125 27.2522 34.5338 27.4329 34.6082 27.5924C35.8201 30.1863 39.4346 30.165 39.4346 30.165Z",
    fill: "url(#paint8_radial_4760_27374)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.458 19.5549C36.4792 18.6407 37.4892 18.0985 39.1901 18.141C40.6359 18.1835 43.7932 19.0659 45.8982 21.9468C46.2915 22.4784 45.6537 22.7441 45.271 22.3934C43.9633 21.2133 40.402 19.64 37.5849 19.8738C36.4474 19.9589 36.458 19.5549 36.458 19.5549Z",
    fill: "url(#paint9_linear_4760_27374)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5972 26.1997C37.2131 27.0821 39.3712 28.3259 43.5172 26.5506C44.0806 26.3061 44.3677 26.5612 44.4314 26.8588C43.868 26.4974 42.975 28.2834 39.4987 28.2834C35.4803 28.2834 34.8743 26.0722 34.4385 26.8695C34.4704 26.338 35.0444 25.8914 35.5972 26.1997Z",
    fill: "url(#paint10_linear_4760_27374)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4760_27374",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8592 21.0934) scale(27.5731)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDF30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB82E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4760_27374",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.8592 21.0934) scale(21.693)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE95F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBB47",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4760_27374",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.904 36.0422) rotate(-2.7703) scale(9.61387 7.60702)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    stopColor: "#FF4C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1795,
    stopColor: "#FF4C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3996,
    stopColor: "#FA4C0B",
    stopOpacity: 0.7318
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    stopColor: "#EE4B27",
    stopOpacity: 0.2683
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64A3A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4760_27374",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.7975 36.0423) rotate(-177.23) scale(9.61387 7.60702)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1542,
    stopColor: "#FF4C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1795,
    stopColor: "#FF4C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3996,
    stopColor: "#FA4C0B",
    stopOpacity: 0.7318
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7799,
    stopColor: "#EE4B27",
    stopOpacity: 0.2683
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64A3A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4760_27374",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.2706 28.1247) rotate(-179.852) scale(3.88357 1.87349)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4760_27374",
    x1: 19.4615,
    y1: 21.2171,
    x2: 19.3931,
    y2: 18.8097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4760_27374",
    x1: 30.3565,
    y1: 38.6574,
    x2: 30.3565,
    y2: 42.0696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4760_27374",
    x1: 16.2701,
    y1: 27.1932,
    x2: 26.2648,
    y2: 27.1932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_4760_27374",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.435 28.1247) rotate(-0.147672) scale(3.88357 1.87349)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#7A4400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4760_27374",
    x1: 41.2445,
    y1: 21.2172,
    x2: 41.3129,
    y2: 18.8098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A4400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4760_27374",
    x1: 44.4426,
    y1: 27.1932,
    x2: 34.4479,
    y2: 27.1932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00132565,
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#512D00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContent);
export default __webpack_public_path__ + "static/media/icon_content.752e080589430a44dc1fe736e86e5f23.svg";
export { ForwardRef as ReactComponent };